import { render, staticRenderFns } from "./StatementBookTabsComponent.vue?vue&type=template&id=82d5d532&scoped=true&"
import script from "./StatementBookTabsComponent.vue?vue&type=script&lang=js&"
export * from "./StatementBookTabsComponent.vue?vue&type=script&lang=js&"
import style0 from "./StatementBookTabsComponent.vue?vue&type=style&index=0&id=82d5d532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d5d532",
  null
  
)

component.options.__file = "StatementBookTabsComponent.vue"
export default component.exports